import React, { useEffect } from "react";
import PeopleDetails from "./PeopleDetails";
import CompanyDetails from "./CompanyDetails";
import SalesDetails from "./SalesDetails";
import BusinessCardScannerPanel from "./BusinessCardScannerPanel";

// Default columns for company details if none are provided
const defaultCompanyColumns = [
  {
    Header: "Status",
    accessor: "status",
    DropdownOptions: [
      "New",
      "Active",
      "Inactive"
    ]
  },
  {
    Header: "Name",
    accessor: "name"
  },
  {
    Header: "Website",
    accessor: "website"
  },
  {
    Header: "Industry",
    accessor: "industry"
  },
  {
    Header: "Revenue",
    accessor: "revenue"
  },
  {
    Header: "Employee Count",
    accessor: "employee_count"
  },
  {
    Header: "Phone",
    accessor: "phone"
  },
  {
    Header: "Email",
    accessor: "email"
  },
  {
    Header: "Notes",
    accessor: "notes"
  },
  {
    Header: "Address",
    accessor: "address"
  }
];

const RightDetails = (props) => {
  const { fromPage, data, onSave, onClose } = props;
  
  // Log which component will be rendered
  console.log("RightDetails rendering with fromPage:", fromPage);
  console.log("RightDetails data:", data);
  
  // Prepare a safe onSave handler that won't cause issues
  const handleSave = async (result) => {
    console.log("RightDetails.handleSave called with:", result);
    if (onSave) {
      try {
        return await onSave(result);
      } catch (error) {
        console.error("Error in RightDetails.handleSave:", error);
        return false;
      }
    }
    return true;
  };
  
  // Check for business card scanner
  const isBusinessCardScanner = data && data.__isBusinessCardScanner === true;
  if (isBusinessCardScanner) {
    console.log("Rendering BusinessCardScannerPanel");
    return <BusinessCardScannerPanel {...props} onSave={handleSave} />;
  }
  
  // Check for our special company flag
  const isCompanyData = data && data.__isCompanyDetails === true;
  if (isCompanyData) {
    console.log("Detected company data via flag, rendering CompanyDetails component");
    // Remove our special flag before passing to CompanyDetails
    const { __isCompanyDetails, ...cleanData } = data;
    // Use company-specific columns instead of people columns
    return <CompanyDetails 
      {...props} 
      data={cleanData} 
      fromPage="Company"
      columns={defaultCompanyColumns} 
    />;
  }
  
  // Check for our special person flag
  const isPersonData = data && data.__isPersonDetails === true;
  if (isPersonData) {
    console.log("Detected person data via flag, rendering PeopleDetails component");
    // Remove our special flag before passing to PeopleDetails
    const { __isPersonDetails, ...cleanData } = data;
    return <PeopleDetails {...props} data={cleanData} fromPage="People" />;
  }
  
  // Force the use of SalesDetails if the data appears to be a sale record
  const isSalesData = data && 
    (data.fromPage === "Sales" || 
     (data.transaction_date && data.total_amount !== undefined));
  
  if (isSalesData) {
    console.log("Detected sales data, rendering SalesDetails component");
    return <SalesDetails {...props} fromPage="Sales" onSave={handleSave} />;
  }
  
  if (fromPage === "Company") {
    console.log("Rendering CompanyDetails component");
    return <CompanyDetails {...props} columns={defaultCompanyColumns} fromPage={fromPage} />;
  }
  
  if (fromPage === "Sales") {
    console.log("Rendering SalesDetails component");
    return <SalesDetails {...props} fromPage={fromPage} onSave={handleSave} />;
  }
  
  console.log("Rendering PeopleDetails component (default)");
  return <PeopleDetails {...props} fromPage={fromPage} />;
};

export default RightDetails;
